var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Tabs',{attrs:{"tab":_vm.tab},on:{"checkTab":_vm.checkTab}}),_c(_vm.tab,{tag:"router-view",attrs:{"type":_vm.type,"formData":_vm.formData},on:{"stopQuery":function($event){return _vm.$emit('stopQuery')},"checkTab":_vm.checkTab}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }